let rsvpGuestData = null;
let rsvpCurrentCount = 1;
// ── Helpers de visibilidad de paneles ─────────────────────────
function showRSVPPanel(panelName) {
    const loadingEl = document.getElementById("rsvp-loading");
    const noIdEl = document.getElementById("rsvp-no-id");
    const confirmedEl = document.getElementById("rsvp-confirmed");
    const canceledEl = document.getElementById("rsvp-canceled");
    const formEl = document.getElementById("rsvp-form");
    const sectionWrapper = document.getElementById("rsvp-section-wrapper-pending-confirmation");
    loadingEl.style.display = panelName === "loading" ? "flex" : "none";
    noIdEl.classList.toggle("visible", panelName === "no-id");
    confirmedEl.classList.toggle("visible", panelName === "confirmed");
    canceledEl.classList.toggle("visible", panelName === "canceled");
    formEl.classList.toggle("visible", panelName === "form");
    sectionWrapper.style.display = panelName === "confirmed" || panelName === "canceled" ? "none" : "block";
}
// ── Carga de datos del invitado ────────────────────────────────
async function loadGuestData() {
    try {
        showRSVPPanel("loading");
        if (!CONFIG.testingMode) {
            const urlParams = new URLSearchParams(window.location.search);
            const guestId = urlParams.get("id");
            if (!guestId) {
                showRSVPPanel("no-id");
                return;
            }
            const response = await fetch(`/guest?id=${guestId}`);
            if (!response.ok) throw new Error("No se pudo cargar la invitaci\xf3n");
            rsvpGuestData = await response.json();
        } else rsvpGuestData = {
            nombre: "Invitado 1 & Invitado 2",
            lugaresAsignados: 2,
            mesa: 1,
            confirmados: 0,
            estado: "Pendiente",
            mensajePersonalizado: "HOLA ESTE ES UN MENSAJE PERSONALIZADO. LO ESCRIBI EN MAYUSCULAS, SALE EN MAYUSCULAS? NO DEBERIA."
        };
        if (!rsvpGuestData || !rsvpGuestData.nombre || !rsvpGuestData.lugaresAsignados) throw new Error("No se pudo cargar la invitaci\xf3n");
        const personalCard = document.getElementById("personal-card");
        if (personalCard) {
            personalCard.classList.add("visible");
            document.getElementById("guest-name-display").textContent = rsvpGuestData.nombre;
            document.getElementById("guest-seats-display").textContent = rsvpGuestData.lugaresAsignados;
            document.getElementById("guest-seats-key-display").textContent = rsvpGuestData.lugaresAsignados > 1 ? "lugares" : "lugar";
            document.getElementById("guest-table-display").textContent = rsvpGuestData.mesa ?? "\u2014";
            document.getElementById("guest-custom-message").textContent = rsvpGuestData.mensajePersonalizado && rsvpGuestData.mensajePersonalizado !== "" ? rsvpGuestData.mensajePersonalizado : rsvpGuestData.lugaresAsignados > 1 ? "con mucho cari\xf1o los esperamos" : "le esperamos con mucho cari\xf1o";
        }
        document.getElementById("rsvp-guest-name").textContent = rsvpGuestData.nombre;
        rsvpCurrentCount = rsvpGuestData.confirmados ?? 1;
        if (rsvpCurrentCount === 0) rsvpCurrentCount = 1;
        renderCounterDisplay();
        if (rsvpGuestData.estado === "Cancelado") showRSVPPanel("canceled");
        else if (rsvpGuestData.estado === "Confirmado" && rsvpGuestData.confirmados !== null) showConfirmedPanel();
        else showRSVPPanel("form");
    } catch (error) {
        console.error("Error cargando invitado:", error);
        showRSVPPanel("no-id");
    }
}
// ── Contador +/− ───────────────────────────────────────────────
function renderCounterDisplay() {
    if (!rsvpGuestData) return;
    const maxAllowed = rsvpGuestData.lugaresAsignados;
    document.getElementById("rsvp-counter-value").textContent = rsvpCurrentCount;
    document.getElementById("rsvp-counter-minus").disabled = rsvpCurrentCount <= 1;
    document.getElementById("rsvp-counter-plus").disabled = rsvpCurrentCount >= maxAllowed;
    document.getElementById("rsvp-counter-max-note").textContent = `M\xe1ximo ${maxAllowed} ${maxAllowed === 1 ? "lugar" : "lugares"} para esta invitaci\xf3n. Les agradecemos respetar que esta celebraci\xf3n ha sido organizada \xfanicamente para los nombres incluidos en la invitaci\xf3n.`;
}
function incrementCounter() {
    if (!rsvpGuestData) return;
    const next = rsvpCurrentCount + 1;
    if (next > rsvpGuestData.lugaresAsignados) return;
    rsvpCurrentCount = next;
    renderCounterDisplay();
    hideCounterError();
}
function decrementCounter() {
    if (!rsvpGuestData) return;
    const next = rsvpCurrentCount - 1;
    if (next < 1) return;
    rsvpCurrentCount = next;
    renderCounterDisplay();
    hideCounterError();
}
function hideCounterError() {
    document.getElementById("rsvp-count-error")?.classList.remove("visible");
}
// ── Envío de confirmación ──────────────────────────────────────
async function submitRSVP(cancelado) {
    if (!rsvpGuestData) return;
    if (cancelado) rsvpCurrentCount = 0;
    else if (rsvpCurrentCount < 1) {
        document.getElementById("rsvp-count-error").classList.add("visible");
        return;
    }
    if (rsvpCurrentCount > rsvpGuestData.lugaresAsignados) {
        document.getElementById("rsvp-count-error").classList.add("visible");
        return;
    }
    const submitBtn = document.getElementById("rsvp-submit-btn");
    const submitLabel = document.getElementById("rsvp-submit-label");
    submitBtn.disabled = true;
    submitLabel.textContent = "Confirmando...";
    document.getElementById("rsvp-general-error").classList.remove("visible");
    try {
        if (!CONFIG.testingMode) {
            const response = await fetch("/confirm", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    pageId: rsvpGuestData.id,
                    confirmados: rsvpCurrentCount,
                    lugaresAsignados: rsvpGuestData.lugaresAsignados
                })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.error || "Error al confirmar");
        }
        rsvpGuestData.confirmados = rsvpCurrentCount;
        if (cancelado) {
            rsvpGuestData.estado = "Cancelado";
            showRSVPPanel("canceled");
        } else {
            rsvpGuestData.estado = "Confirmado";
            showConfirmedPanel();
        }
    } catch (error) {
        const errorEl = document.getElementById("rsvp-general-error");
        errorEl.textContent = error.message || "Ocurri\xf3 un error. Intenta de nuevo.";
        errorEl.classList.add("visible");
        submitLabel.textContent = "Confirmar Asistencia";
    }
    submitBtn.disabled = false;
}
// ── Panel de confirmación exitosa ──────────────────────────────
function showConfirmedPanel() {
    const confirmed = rsvpGuestData.confirmados;
    const tableNumberDesc = rsvpGuestData.mesa ? `Asignado${confirmed > 1 ? "s" : ""} en la mesa #${rsvpGuestData.mesa}` : "<i>El n\xfamero de mesa ser\xe1 asignado mas adelante</i>";
    document.getElementById("confirmed-guest-name").textContent = rsvpGuestData.nombre;
    document.getElementById("confirmed-detail").innerHTML = `\xa1Asistencia confirmada!<br>
     <strong>${confirmed} ${confirmed === 1 ? "persona" : "personas"}.</strong><br>
     ${tableNumberDesc}.<br>
     Muchas gracias por ser parte de este momento especial para nosotros, los esperamos con mucho amor.`;
    showRSVPPanel("confirmed");
}
// ── Modificar confirmación existente ──────────────────────────
function showModifyForm() {
    rsvpCurrentCount = rsvpGuestData.confirmados ?? 1;
    if (rsvpCurrentCount === 0) rsvpCurrentCount = 1;
    renderCounterDisplay();
    showRSVPPanel("form");
    document.getElementById("rsvp-submit-label").textContent = "Actualizar Confirmaci\xf3n";
    document.getElementById("rsvp").scrollIntoView({
        behavior: "smooth"
    });
}
// ── Inicialización ─────────────────────────────────────────────
function initRSVP() {
    loadGuestData();
}

//# sourceMappingURL=public.4bd4d15b.js.map
